import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  getUserEnrollments,
  getUserEntitlements,
  getUserLoggedIn,
} from '@data/actions/user';

export default function withUser(ComponentToWrap) {
  // eslint-disable-next-line react/prefer-stateless-function
  function UserAwareComponent({
    // Remove the dispatchers from the props that are passed to the wrapped component.
    requestUserEnrollments,
    requestUserEntitlements,
    requestUserLoggedIn,
    ...props
  }) {
    const { userLoggedIn } = props;

    const getUserActivity = useCallback(() => {
      if (userLoggedIn) {
        requestUserEnrollments();
        requestUserEntitlements();
      }
    }, [userLoggedIn]);

    useEffect(() => {
      requestUserLoggedIn();
      getUserActivity(userLoggedIn);
    }, [userLoggedIn]);

    return <ComponentToWrap {...props} />;
  }

  UserAwareComponent.propTypes = {
    userEnrollments: PropTypes.arrayOf(
      PropTypes.shape({
        courseId: PropTypes.string.isRequired,
        mode: PropTypes.string.isRequired,
      }),
    ),
    userEntitlements: PropTypes.arrayOf(
      PropTypes.shape({
        courseUuid: PropTypes.string.isRequired,
      }),
    ),
    userLoggedIn: PropTypes.bool,
    requestUserEnrollments: PropTypes.func.isRequired,
    requestUserEntitlements: PropTypes.func.isRequired,
    requestUserLoggedIn: PropTypes.func.isRequired,
  };

  UserAwareComponent.defaultProps = {
    userEnrollments: [],
    userEntitlements: [],
    userLoggedIn: false,
  };

  const mapStateToProps = (store) => ({
    userEnrollments:
      store.userEnrollments && store.userEnrollments.userEnrollments,
    userEntitlements:
      store.userEntitlements && store.userEntitlements.userEntitlements,
    userLoggedIn: store.userLoggedIn,
  });

  const mapDispatchToProps = (dispatch) => ({
    requestUserEnrollments() {
      dispatch(getUserEnrollments());
    },
    requestUserEntitlements() {
      dispatch(getUserEntitlements());
    },
    requestUserLoggedIn() {
      dispatch(getUserLoggedIn());
    },
  });

  return connect(mapStateToProps, mapDispatchToProps)(UserAwareComponent);
}
